import { z } from 'zod'

export const deleteGroupOrdersInputSchema = z.object({
  order_external_ids: z
    .array(z.string().trim().min(1))
    .min(1)
    .transform((ids) => [...new Set(ids)]),
})

/** WEBLP-3079: HTTP 200 can still contain per-order failures. */
export const deleteGroupOrdersResponseSchema = z.object({
  deleted_order_external_ids: z.array(z.string()),
  failed_orders: z.array(z.object({ order_external_id: z.string(), error: z.string() })),
})

export type DeleteGroupOrdersResponse = z.infer<typeof deleteGroupOrdersResponseSchema>
export type DeleteOrdersTarget = { all: true } | { ids: string[] }

export function deleteOrdersCount(target: DeleteOrdersTarget | null): number {
  return target && 'ids' in target ? target.ids.length : 0
}

export function deleteOrdersFeedback(result: DeleteGroupOrdersResponse) {
  const deleted = result.deleted_order_external_ids.length
  const failed = result.failed_orders.length
  if (failed > 0) {
    return {
      variant: deleted > 0 ? ('info' as const) : ('error' as const),
      title: deleted > 0 ? 'Sebagian pesanan berhasil dihapus' : 'Gagal hapus pesanan',
      description: `${deleted} pesanan berhasil dihapus. ${failed} pesanan gagal dihapus. Muat ulang atau coba lagi.`,
    }
  }
  return {
    variant: deleted > 0 ? ('success' as const) : ('info' as const),
    title: deleted > 0 ? 'Pesanan berhasil dihapus' : 'Tidak ada pesanan yang dihapus',
    description: deleted > 0 ? '' : 'Tidak ada pesanan Belum bayar yang dapat dihapus.',
  }
}
